import { render, staticRenderFns } from "./NeetMenuDocente.vue?vue&type=template&id=497a2d72"
import script from "./NeetMenuDocente.vue?vue&type=script&lang=js"
export * from "./NeetMenuDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports